 <div class="col-sm-12 time_header">
      <form>
          <div class="form-group position_input custome_date">
            <button id="date-picker-btn" name="date-picker-btn" class="btn btn-primary time_stamp_btn waves-effect waves-light" align="right" style="font-size: 11px !important;">
                <div class="left_div">
                    <i class="fa fa-calendar-alt" ></i>
                </div>
                <div class="right_div">
                    <div>
                        <a id="label-startdate" name="label-startdate" class="ancher_tg">Start Date : </a> <span id="startdate" name="startdate"> 
                             <!-- 28-04-2022 18:39 -->
                             {{selectedRange?.startDate | date: 'dd-MM-yyyy HH:mm'}}
                            </span>
                    </div>
                    <div class="end_date">
                        <a id="label-enddate" name="label-enddate" class="ancher_tg">End Date : </a> <span id="enddate" name="enddate"> 
                            <!-- 28-04-2022 18:54 -->
                            {{selectedRange?.endDate | date: 'dd-MM-yyyy HH:mm'}}
                        </span>
                    </div>
                </div>
               </button>
              <input id="datepicker" style="color: transparent !important;"
      type="text" 
      name="daterange"
      autocomplete="off" readonly
      ngxDaterangepickerMd
      (change)="choosedDate($event)"
      (rangeClicked)="handleRangeClick($event)"
      [(ngModel)]="selectedRange" 
      [ngModelOptions]="{standalone: true}"
      [alwaysShowCalendars]="true"
      [showCustomRangeLabel]="true"
      [showClearButton]="true"
      [showDropdowns]="true"
      [linkedCalendars]="false"
      [ranges]="ranges"
      [locale]="calendarLocale" 
      [placeholder]="calendarPlaceholder"
      [keepCalendarOpeningWithRange]="true" 
      [minDate]="minDate"
      [maxDate]="maxDate"
      [timePicker]="true"
      [timePicker24Hour]="true"
      [timePickerIncrement]="1"
      [timePickerSeconds]="false"
      class="form-control date_inputField" />
          </div>
      </form> 
</div>





<!-- 
<button for="actual-btn"
class="btn btn-primary waves-effect waves-light"
style=" height: 53px; padding-top: 4px; " align:right
>
<div
style=
"margin-right: 10px;
height: 50px; 
float: left;
padding-top: 8px">
<i
className="fa fa-calendar-alt"
style=" font-Size: 24px"
></i>
</div>
<div style=" float: left; text-align: left">
<div>
<a style="font-weight:900">Start Date</a>
{{this.selectedRange.startDate.format("DD-MM-YYYY HH:mm")}}
</div>
<div>
<a style="font-weight:900">End Date</a>
{{this.selectedRange.endDate.format("DD-MM-YYYY HH:mm")}}
</div>
</div>
</button> -->